var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFont1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.8 500",
    style: {
      enableBackground: "new 0 0 325.8 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#010101;stroke-width:25;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "150.7,77.2 77.676,360.278 67.364,394.564 63.472,405.467 61.817,409.246 59.701,412.46 57.274,410.829 57.121,406.823 57.798,398.906 84.953,245.341 89.012,213.675 96.977,130.158 100.987,102.485 104.131,86.817 106.145,79.082 108.562,71.466 111.468,64.024 114.944,56.828 116.921,53.353 119.071,49.985 121.406,46.745 123.944,43.66 126.701,40.764 129.685,38.108 132.902,35.747 136.356,33.737 140.019,32.148 143.846,31.008 147.778,30.31 151.765,30.042 155.757,30.183 159.715,30.715 163.608,31.619 167.401,32.876 171.063,34.469 174.57,36.385 177.893,38.606 181.019,41.088 183.959,43.791 186.726,46.675 191.8,52.851 196.37,59.403 202.572,69.662 211.88,87.319 226.634,120.127 246.761,172.324 257.995,206.476 265.309,233.468 270.243,256.91 276.072,296.449 280.581,344.178 282.081,380.091 281.65,420.005 278.4,475.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "31.5,265.6 78.17,254.53 101.744,250.17 185.014,240.516 291.6,223.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "66.8,60.2 78.187,262.149 81.9,460.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "74.4,82.2 96.391,64.956 112.797,53.502 122.974,47.207 133.47,41.495 144.325,36.468 155.472,32.127 163.06,29.649 170.771,27.58 178.592,25.987 186.499,24.922 194.462,24.409 202.444,24.443 210.406,25.009 218.315,26.091 226.138,27.674 233.849,29.74 241.419,32.273 248.823,35.254 256.043,38.66 263.058,42.47 269.849,46.667 276.395,51.236 282.668,56.171 288.611,61.502 294.132,67.265 299.121,73.494 301.377,76.787 303.449,80.198 305.32,83.723 306.975,87.355 308.406,91.074 309.618,94.876 310.606,98.745 311.369,102.668 311.905,106.629 312.211,110.613 312.285,114.605 312.124,118.591 311.727,122.555 311.088,126.495 310.213,130.389 309.119,134.227 306.357,141.714 302.961,148.937 299.076,155.912 292.594,165.978 285.514,175.635 280.441,181.799 275.056,187.692 269.337,193.26 263.265,198.442 256.842,203.18 250.105,207.461 243.097,211.281 235.857,214.642 228.421,217.546 220.825,219.999 213.101,222.015 205.28,223.612 193.423,225.271 181.478,226.104 169.494,226.157 157.544,225.401 145.69,223.791 137.867,222.221 110.884,214.973 106.965,214.144 103.023,213.546 99.035,213.301 95.069,213.599 91.209,214.596 87.664,216.413 84.832,219.209 83.569,222.934 84.6,226.738 87.19,229.768 90.34,232.185 93.745,234.273 100.872,237.894 137.504,253.728 155.312,262.728 179.394,276.905 212.657,298.999 231.962,313.148 244.368,323.231 253.173,331.333 258.699,337.085 263.877,343.15 268.676,349.529 273.042,356.212 276.877,363.21 280.058,370.532 281.354,374.307 282.426,378.15 283.251,382.055 283.807,386.007 284.079,389.989 284.07,393.98 283.781,397.961 283.217,401.912 282.383,405.815 281.282,409.652 279.92,413.404 278.303,417.052 276.437,420.58 274.329,423.97 271.99,427.204 269.442,430.275 266.71,433.184 263.816,435.934 257.626,440.974 251.012,445.44 244.073,449.387 236.885,452.859 229.503,455.897 218.163,459.737 206.604,462.862 187.061,466.913 171.271,469.275 155.385,470.821 139.439,471.498 123.472,471.248 103.577,469.765 87.763,467.783 68.139,464.204 37.104,456.592 17.9,451.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "283.2,72.7 268.501,66.201 257.347,62.071 249.71,59.717 241.932,57.777 234.049,56.343 226.113,55.512 218.148,55.368 210.182,55.968 202.305,57.296 194.562,59.238 186.977,61.736 179.587,64.764 172.406,68.26 161.982,74.164 131.77,93.653 112.296,107.629 93.592,122.626 78.745,135.973 67.463,147.288 59.479,156.226 52.026,165.61 45.228,175.478 41.138,182.342 37.472,189.44 34.298,196.771 31.693,204.323 29.739,212.068 28.481,219.956 27.914,227.924 28.023,235.912 28.794,243.863 30.21,251.725 32.25,259.448 34.864,266.998 37.983,274.352 41.542,281.505 47.579,291.857 54.308,301.773 61.597,311.286 71.998,323.416 88.62,340.677 115.032,365.074 139.558,385.585 158.698,400.006 175.257,411.175 188.943,419.402 203.062,426.883 213.938,431.917 225.061,436.378 236.422,440.186 244.132,442.281 251.941,443.948 259.835,445.155 267.787,445.895 275.771,446.187 283.766,446.049 291.709,445.321 295.638,444.666 299.534,443.795 303.394,442.701 307.161,441.4 310.836,439.902 317.988,436.324 324.796,432.094 331.24,427.351 337.335,422.211 345.918,413.921 351.4,408.0 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "170.4,22.8 179.7,477.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17.7,142.0 40.064,119.015 54.656,105.404 66.866,95.112 79.645,85.495 96.241,74.365 106.552,68.233 117.176,62.661 128.112,57.739 139.34,53.516 150.831,50.075 158.62,48.264 166.497,46.879 174.441,45.954 182.426,45.524 190.422,45.627 198.391,46.298 206.285,47.571 214.051,49.475 221.634,52.012 228.989,55.152 236.073,58.861 242.848,63.109 249.273,67.87 255.31,73.114 260.949,78.784 266.202,84.813 271.092,91.142 277.807,101.082 283.862,111.437 289.315,122.122 295.714,136.78 301.201,151.804 306.906,170.965 311.484,190.427 315.043,210.092 317.497,229.943 318.727,249.91 318.761,269.902 317.687,289.86 315.511,309.728 312.169,329.44 308.539,345.017 305.102,356.51 300.926,367.755 297.685,375.066 292.151,385.708 285.873,395.929 278.916,405.701 271.321,414.985 265.866,420.835 260.058,426.332 253.868,431.394 247.279,435.923 243.835,437.954 240.293,439.811 236.659,441.477 232.94,442.941 229.144,444.193 225.282,445.228 221.366,446.044 217.41,446.642 213.427,447.026 205.436,447.191 197.459,446.617 189.59,445.289 181.901,443.196 174.376,440.398 167.146,437.063 160.13,433.277 149.884,426.894 136.944,417.604 127.5,410.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "244.0,17.5 192.663,24.749 169.179,29.256 149.862,34.059 134.642,38.787 123.465,43.023 112.573,47.952 102.032,53.592 91.899,59.938 82.248,66.994 76.125,72.097 70.289,77.528 64.852,83.354 62.334,86.444 59.98,89.657 57.807,92.995 55.832,96.454 54.066,100.025 52.516,103.695 51.183,107.451 50.065,111.275 49.177,115.11 48.584,118.947 48.253,122.92 48.13,130.781 49.801,158.334 88.5,471.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "28.9,284.5 278.1,244.501 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "100.1,465.3 249.4,484.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "92.0,67.4 107.7,481.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "18.4,86.2 269.1,18.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "32.5,266.5 327.1,257.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "305.5,32.4 286.221,27.186 270.618,23.81 258.745,21.918 246.835,20.782 238.9,20.543 230.898,20.787 222.968,21.542 215.091,22.772 207.292,24.455 199.604,26.609 192.062,29.228 184.685,32.279 173.928,37.529 160.057,45.434 146.712,54.196 133.903,63.722 118.643,76.563 104.149,90.291 90.379,104.748 79.987,116.868 70.311,129.56 63.606,139.501 57.448,149.78 51.894,160.378 46.998,171.285 42.784,182.49 39.233,193.923 36.305,205.536 33.311,221.219 31.798,233.096 31.037,245.045 31.01,253.028 31.408,261.0 32.255,268.949 33.548,276.831 35.285,284.621 37.462,292.295 40.078,299.827 43.128,307.203 48.419,317.944 54.387,328.323 65.342,345.004 77.18,361.066 87.398,373.336 95.572,382.094 104.195,390.425 116.302,400.836 129.021,410.442 142.355,419.258 152.697,425.274 163.33,430.753 174.253,435.659 185.458,439.881 193.084,442.239 200.829,444.173 208.677,445.627 216.608,446.54 224.584,446.842 232.554,446.444 236.516,445.954 240.446,445.253 244.328,444.328 248.147,443.171 251.883,441.771 255.513,440.126 259.022,438.238 262.405,436.125 268.802,431.358 274.776,426.093 283.256,417.585 309.369,387.444 336.435,352.82 352.553,329.953 358.924,319.863 362.891,312.875 366.414,305.731 367.96,302.036 369.285,298.272 370.31,294.426 370.906,290.513 370.869,286.508 369.913,282.668 367.84,279.273 364.852,276.66 361.324,274.813 357.539,273.558 353.624,272.709 345.722,271.767 205.992,271.959 178.09,270.708 162.199,269.125 154.319,267.882 146.509,266.193 138.857,263.925 135.101,262.537 131.446,260.958 127.915,259.102 124.686,256.731 124.168,253.38 127.92,252.077 131.847,251.572 319.51,254.084 343.451,255.376 355.346,256.685 363.132,258.167 366.983,259.23 370.732,260.588 374.334,262.311 377.707,264.44 380.785,266.963 383.538,269.819 385.835,273.024 387.551,276.571 388.771,280.403 389.576,284.278 390.095,288.152 390.578,296.131 390.422,308.025 388.929,327.799 380.002,390.872 363.1,481.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "51.5,20.4 43.6,451.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "245.1,16.4 241.533,312.353 234.082,415.992 226.5,483.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "51.5,230.9 287.3,197.1 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "51.7,24.4 56.822,291.945 51.7,475.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "39.8,54.0 386.4,38.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "201.3,19.8 265.466,174.607 273.476,197.139 279.118,216.269 283.626,235.698 287.666,259.277 291.395,290.982 292.529,306.899 292.743,318.864 292.465,326.837 291.78,334.786 290.029,346.623 286.645,362.216 281.339,381.443 277.62,392.819 274.758,400.267 271.485,407.541 267.714,414.571 263.381,421.268 258.507,427.583 253.162,433.506 247.41,439.033 241.304,444.168 234.891,448.915 228.209,453.274 221.279,457.227 214.122,460.753 206.762,463.83 199.22,466.433 191.526,468.538 183.705,470.11 175.796,471.112 167.834,471.543 159.859,471.436 151.906,470.844 144.003,469.831 136.181,468.302 128.574,466.092 121.093,463.237 110.347,458.181 96.288,450.331 69.707,433.11 30.8,404.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "75.3,18.0 89.4,455.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "250.9,71.6 68.868,226.822 60.153,235.021 54.806,240.932 52.364,244.078 50.131,247.389 48.179,250.864 46.578,254.509 45.395,258.316 44.654,262.231 44.35,266.205 44.468,270.188 44.985,274.141 45.874,278.028 47.106,281.817 48.655,285.491 50.497,289.03 52.603,292.411 54.949,295.633 57.494,298.704 63.035,304.437 68.992,309.734 122.889,350.807 135.042,361.04 169.061,394.421 250.9,482.0 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "37.6,28.8 39.734,359.447 41.298,394.559 42.688,410.545 43.779,418.399 44.541,422.424 45.439,426.111 46.687,429.958 48.25,433.492 50.189,436.89 52.462,440.143 55.124,443.083 58.094,445.589 61.387,447.768 64.942,449.668 68.45,451.238 75.942,453.945 87.378,457.086 106.721,461.015 154.068,467.577 261.3,477.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "85.0,54.0 39.659,379.004 37.756,398.735 37.565,406.66 37.901,410.53 38.712,414.439 40.145,418.144 42.603,421.273 46.292,422.51 49.957,421.064 52.741,418.227 54.84,414.827 56.505,411.204 59.163,403.645 122.031,106.423 127.047,87.06 130.572,75.637 133.323,68.073 136.485,60.776 138.309,57.227 140.378,53.787 142.778,50.575 145.659,47.854 149.294,46.306 153.081,47.258 155.819,50.106 157.8,53.561 159.406,57.196 163.304,68.492 218.711,281.372 228.152,312.09 233.495,327.03 238.142,338.161 241.66,345.224 243.712,348.726 245.985,352.015 248.61,354.965 251.889,357.24 255.762,357.687 259.272,355.875 261.909,352.924 263.941,349.441 265.575,345.808 268.272,338.291 312.525,159.715 321.588,129.03 326.944,114.035 330.065,106.627 333.652,99.467 335.722,96.05 338.085,92.84 340.897,90.048 344.409,88.254 348.285,88.651 351.49,91.003 353.756,94.086 355.477,97.662 358.131,105.024 445.3,483.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "85.0,54.0 39.659,379.004 37.756,398.735 37.565,406.66 37.901,410.53 38.712,414.439 40.145,418.144 42.603,421.273 46.292,422.51 49.957,421.064 52.741,418.227 54.84,414.827 56.505,411.204 59.163,403.645 122.031,106.423 127.047,87.06 130.572,75.637 133.323,68.073 136.485,60.776 138.309,57.227 140.378,53.787 142.778,50.575 145.659,47.854 149.294,46.306 153.081,47.258 155.819,50.106 157.8,53.561 159.406,57.196 163.304,68.492 218.711,281.372 228.152,312.09 233.495,327.03 238.142,338.161 241.66,345.224 243.712,348.726 245.985,352.015 248.61,354.965 251.889,357.24 255.762,357.687 259.272,355.875 261.909,352.924 263.941,349.441 265.575,345.808 268.272,338.291 312.525,159.715 321.588,129.03 326.944,114.035 330.065,106.627 333.652,99.467 335.722,96.05 338.085,92.84 340.897,90.048 344.409,88.254 348.285,88.651 351.49,91.003 353.756,94.086 355.477,97.662 358.131,105.024 445.3,483.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "69.1,79.2 52.744,386.631 52.316,426.629 52.854,442.603 53.495,450.515 54.014,454.486 54.8,458.368 56.435,461.893 59.167,459.948 60.319,456.112 61.029,452.184 62.256,440.246 68.664,292.527 68.405,192.6 65.283,120.766 65.467,104.782 65.992,96.809 67.002,88.863 67.819,84.952 69.053,81.16 71.323,77.93 75.032,78.264 77.939,80.978 80.365,84.176 84.531,91.008 89.945,101.7 96.314,116.356 145.311,255.85 179.397,336.886 193.089,365.777 198.762,376.345 202.88,383.186 207.389,389.767 212.409,395.989 215.126,398.918 217.99,401.703 221.014,404.32 224.212,406.726 227.585,408.847 231.186,410.605 234.978,411.823 238.943,412.279 242.88,411.7 246.474,410.001 249.588,407.487 252.25,404.528 254.603,401.28 256.701,397.888 260.42,390.813 271.426,365.107 281.025,338.822 290.177,308.201 306.619,238.268 308.625,226.546 312.173,190.893 319.1,18.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "28.8,178.2 62.545,133.569 77.938,115.276 88.897,103.652 100.512,92.702 109.704,85.028 119.297,77.865 132.648,69.072 143.024,63.1 153.708,57.724 164.713,52.991 175.977,48.965 187.507,45.68 199.233,43.203 207.127,42.034 215.075,41.27 223.053,40.925 231.038,41.008 239.005,41.533 246.93,42.515 254.781,43.968 262.528,45.9 270.143,48.302 277.6,51.154 284.879,54.437 291.962,58.123 298.834,62.188 305.483,66.61 311.892,71.374 318.044,76.465 323.92,81.871 329.501,87.583 334.766,93.589 339.702,99.872 344.294,106.408 348.531,113.178 352.398,120.157 355.888,127.333 360.417,138.419 364.178,149.79 368.209,165.242 372.067,184.804 375.849,212.509 378.68,248.331 379.607,280.263 379.119,300.218 377.777,316.131 376.077,327.987 373.708,339.727 370.606,351.295 366.719,362.623 362.101,373.674 355.029,387.991 347.167,401.893 340.769,412.018 336.162,418.54 331.211,424.806 325.866,430.736 320.085,436.242 313.891,441.28 307.366,445.88 297.116,452.074 282.879,459.309 268.221,465.646 256.946,469.686 249.29,471.954 241.528,473.826 233.672,475.257 225.748,476.236 217.78,476.768 209.796,476.858 201.818,476.511 193.872,475.729 185.98,474.51 178.173,472.834 170.486,470.677 162.957,468.016 155.637,464.829 148.58,461.096 141.83,456.832 135.411,452.085 129.333,446.906 123.602,441.347 118.216,435.453 113.168,429.265 108.459,422.817 104.09,416.133 98.181,405.716 93.063,394.888 88.738,383.72 85.111,372.305 80.262,352.942 76.473,333.352 74.265,317.531 72.972,301.609 72.655,285.652 73.608,261.708 75.818,237.826 78.159,222.048 80.526,210.318 83.511,198.703 87.166,187.286 91.539,176.146 96.683,165.35 102.573,154.922 111.268,141.527 130.148,115.753 145.24,97.157 158.664,82.396 172.878,68.384 187.797,55.11 197.209,47.709 203.788,43.19 210.638,39.092 217.75,35.469 225.093,32.345 232.654,29.79 240.426,27.946 248.303,26.853 256.276,26.447 264.292,26.641 272.249,27.338 284.01,29.123 299.615,32.592 307.4,34.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "79.5,68.7 81.048,428.054 80.226,444.013 79.406,451.947 78.068,459.822 76.939,463.659 74.373,466.3 72.085,463.179 70.898,459.422 69.347,451.607 67.525,435.685 65.399,379.871 65.242,192.098 60.565,104.413 60.642,88.443 61.489,76.497 62.566,68.582 64.207,60.766 65.298,56.927 66.61,53.157 68.179,49.482 70.039,45.95 72.224,42.615 74.769,39.538 77.672,36.802 80.897,34.449 84.367,32.482 88.025,30.884 91.821,29.633 95.702,28.71 99.646,28.089 103.626,27.753 107.62,27.689 111.608,27.886 115.576,28.337 119.506,29.037 123.387,29.976 127.205,31.141 130.951,32.522 134.617,34.104 141.682,37.822 148.358,42.199 154.624,47.148 160.477,52.578 165.955,58.387 173.572,67.631 182.876,80.61 191.479,94.07 199.383,107.945 206.548,122.215 212.88,136.876 216.963,148.136 220.367,159.619 222.204,167.39 223.627,175.249 224.553,183.18 224.889,191.155 224.527,199.132 224.049,203.095 223.356,207.027 222.44,210.913 221.29,214.74 219.898,218.483 218.251,222.119 216.332,225.618 214.123,228.947 211.614,232.051 208.798,234.876 205.674,237.362 202.269,239.441 198.637,241.089 194.848,242.328 190.95,243.2 186.988,243.753 183.013,244.035 175.037,243.96 167.085,243.249 155.265,241.379 147.5,239.628 136.04,236.291 113.62,228.119 36.7,194.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "289.4,61.1 279.557,54.16 269.373,47.79 262.378,43.954 255.179,40.519 247.775,37.586 240.186,35.274 236.257,34.374 232.32,33.686 228.37,33.216 224.404,32.969 220.411,32.947 216.416,33.145 208.492,34.121 200.685,35.781 193.056,38.122 185.657,41.111 178.504,44.665 168.208,50.78 155.045,59.824 145.581,67.168 136.511,74.993 127.875,83.293 114.369,97.995 89.11,128.951 77.287,145.018 68.617,158.421 60.787,172.341 53.756,186.682 47.516,201.378 44.829,208.9 42.535,216.552 40.651,224.307 38.539,236.072 36.804,251.952 35.694,275.904 35.893,303.869 36.995,323.822 38.68,339.682 41.304,355.432 45.878,374.861 50.282,390.209 55.498,405.294 63.086,423.766 75.128,448.992 84.641,466.555 92.949,480.22 99.749,490.08 104.689,496.367 110.001,502.307 115.735,507.852 121.893,512.936 128.423,517.533 138.712,523.653 152.912,530.963 163.886,535.764 171.374,538.541 179.0,540.908 186.759,542.802 194.627,544.163 202.575,544.928 210.56,545.028 218.518,544.387 222.461,543.765 226.367,542.932 230.219,541.886 234.012,540.636 241.39,537.585 248.471,533.894 255.245,529.666 261.718,524.989 267.903,519.937 276.685,511.793 287.659,500.188 310.758,472.656 325.159,453.514 338.37,433.541 354.571,405.999 361.99,391.855 366.872,380.917 369.649,373.43 371.954,365.785 373.804,358.016 375.882,346.22 378.422,322.399 379.964,294.468 380.062,274.526 379.311,258.573 378.044,246.662 376.006,234.859 373.096,223.268 369.361,211.897 364.892,200.764 359.785,189.909 352.124,175.9 341.463,159.018 332.408,145.906 327.489,139.687 322.031,133.996 316.126,128.694 306.793,121.285 283.91,105.441 215.294,64.419 145.0,25.8 ",
    fill: "none",
    fillOpacity: 1,
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "177.0,323.3 223.726,387.762 238.611,406.515 249.079,418.373 257.507,426.787 266.408,434.722 275.71,442.17 285.411,449.095 302.25,459.632 333.758,476.575 337.4,478.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "119.3,64.7 147.8,483.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "83.7,87.5 84.118,75.423 84.94,67.501 86.331,59.626 87.289,55.73 88.448,51.897 89.807,48.215 91.47,44.516 93.394,41.014 95.61,37.716 98.142,34.652 101.001,31.862 104.158,29.404 107.563,27.311 111.164,25.581 114.908,24.188 118.758,23.097 122.681,22.315 126.651,21.854 130.645,21.713 134.637,21.884 138.605,22.354 142.532,23.101 146.402,24.1 150.207,25.327 157.605,28.358 164.711,32.018 171.525,36.199 178.053,40.816 187.35,48.389 196.136,56.553 207.189,68.107 220.132,83.338 234.681,102.407 243.674,115.629 251.892,129.343 259.263,143.528 267.467,161.761 273.329,176.64 277.075,188.031 279.081,195.772 280.558,203.628 281.379,211.579 281.509,215.576 281.438,219.573 281.154,223.559 280.642,227.525 279.89,231.453 278.884,235.321 277.611,239.109 276.058,242.793 274.22,246.342 272.093,249.726 269.701,252.925 267.074,255.933 264.246,258.758 261.248,261.409 254.881,266.236 248.157,270.552 237.665,276.336 234.079,278.084 230.394,279.65 222.913,282.126 215.195,283.978 203.481,285.997 175.759,288.905 63.792,292.611 19.5,292.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "97.9,245.7 234.588,394.995 245.868,406.166 254.735,414.11 264.038,421.536 276.998,430.691 307.341,449.504 338.696,466.511 374.5,483.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "308.2,76.3 292.615,63.862 279.665,54.519 269.588,48.004 259.206,42.096 252.087,38.561 244.771,35.379 233.555,31.306 222.082,27.91 210.424,25.259 202.561,23.967 194.636,23.08 182.693,22.502 170.746,22.761 158.832,23.82 147.007,25.653 135.329,28.231 123.842,31.528 112.571,35.515 101.543,40.162 90.801,45.436 83.846,49.336 77.119,53.619 70.705,58.356 64.716,63.614 61.923,66.459 59.29,69.454 56.838,72.599 54.581,75.885 52.534,79.305 50.714,82.853 49.143,86.519 47.845,90.288 46.846,94.145 46.175,98.076 45.861,102.05 45.931,106.035 46.403,109.991 47.255,113.884 48.45,117.687 49.949,121.384 51.708,124.958 53.698,128.412 55.887,131.746 60.763,138.055 66.173,143.91 72.008,149.344 78.176,154.397 87.895,161.365 101.441,169.78 133.116,186.598 175.882,208.096 196.578,220.061 229.793,242.134 249.103,256.254 264.557,268.823 279.241,282.303 293.091,296.64 303.506,308.715 310.784,318.205 317.449,328.134 321.472,335.018 325.108,342.115 328.335,349.406 331.136,356.871 333.49,364.489 335.376,372.236 336.772,380.086 337.645,388.011 337.941,395.979 337.597,403.943 336.547,411.845 335.736,415.749 334.725,419.605 333.507,423.401 332.086,427.125 330.466,430.767 328.656,434.318 326.661,437.769 324.488,441.113 322.143,444.338 319.633,447.437 316.965,450.401 314.146,453.22 311.18,455.886 308.078,458.389 304.847,460.727 298.06,464.906 290.914,468.44 283.493,471.356 275.869,473.684 268.095,475.456 260.22,476.704 252.284,477.473 240.331,477.833 228.379,477.38 216.486,476.253 200.731,473.834 185.129,470.467 165.939,465.093 147.095,458.605 124.922,449.608 92.541,434.183 74.974,424.816 61.375,416.504 45.026,405.07 23.219,387.722 17.1,382.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "156.3,38.0 116.3,482.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "30.1,17.5 230.016,46.297 320.493,54.352 336.4,55.3 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "406.0,86.5 394.943,197.634 389.839,233.223 386.699,248.885 377.005,283.33 369.344,305.993 358.717,331.79 341.754,367.893 334.228,381.957 328.026,392.187 321.246,402.042 313.86,411.453 305.853,420.339 300.165,425.93 294.2,431.224 287.964,436.195 281.462,440.814 274.703,445.047 267.697,448.858 260.459,452.207 253.006,455.042 245.358,457.302 237.55,458.922 229.629,459.834 221.658,459.981 213.705,459.394 205.828,458.157 198.059,456.353 190.421,454.058 182.922,451.341 171.95,446.578 161.329,441.073 151.074,434.913 141.191,428.172 131.708,420.882 122.678,413.039 114.158,404.638 106.21,395.698 98.838,386.276 92.015,376.45 83.711,362.832 74.429,345.187 61.181,316.166 55.271,301.35 51.451,290.014 48.365,278.457 45.34,262.797 39.581,215.29 37.897,191.428 37.561,159.529 39.434,115.837 48.3,16.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "36.3,134.3 64.581,407.764 67.507,427.394 69.234,435.138 70.498,438.852 72.296,442.347 75.037,445.186 78.829,445.469 82.265,443.423 85.118,440.661 87.66,437.623 92.249,431.145 98.413,421.046 115.005,389.351 147.602,316.779 222.274,119.362 255.8,21.2 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "w.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "33.7,32.9 92.707,350.833 106.115,409.152 111.398,428.298 115.193,439.824 116.741,443.803 118.305,447.301 120.281,450.835 122.836,453.671 126.506,454.234 129.962,452.347 132.492,449.251 134.318,445.746 135.762,442.018 137.987,434.341 180.8,194.7 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "188.1,202.0 213.09,327.419 220.833,358.352 225.579,373.582 241.91,418.586 247.971,433.365 251.339,440.608 255.145,447.622 257.285,451.0 259.621,454.241 262.186,457.294 265.021,460.105 268.147,462.59 271.545,464.674 275.184,466.323 278.997,467.496 282.934,468.159 286.922,468.28 290.888,467.835 294.745,466.811 298.398,465.214 301.767,463.074 304.808,460.494 307.544,457.59 310.018,454.447 312.26,451.146 316.216,444.212 321.249,433.337 326.984,418.451 331.742,403.222 341.855,360.507 359.346,266.207 364.228,230.618 367.76,178.855 368.542,142.988 366.892,107.161 358.4,19.6 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "x.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "21.9,22.2 360.2,477.8 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "360.2,22.2 21.9,464.5 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "y.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "318.6,16.3 21.1,483.901 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "41.1,16.3 169.9,201.4 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "z.1"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "24.1,25.1 254.421,54.794 309.216,64.152 332.709,69.229 344.077,72.246 351.453,74.597 355.394,76.072 358.927,77.606 362.504,79.491 365.635,81.651 368.406,84.446 370.518,87.827 372.105,91.485 373.117,95.334 373.481,99.305 373.211,103.273 372.398,107.165 371.156,110.948 369.584,114.616 367.761,118.181 363.627,124.971 356.608,134.656 343.795,149.974 305.233,190.462 267.894,226.472 255.931,237.039 246.567,244.493 236.801,251.402 219.826,261.873 128.362,310.9 111.302,321.221 101.436,328.007 95.207,332.992 92.253,335.673 89.438,338.506 86.799,341.499 84.372,344.664 82.196,348.007 80.306,351.521 78.711,355.178 77.416,358.953 76.421,362.817 75.728,366.747 75.336,370.718 75.246,374.707 75.458,378.692 75.973,382.649 76.792,386.554 77.915,390.383 79.337,394.108 81.047,397.711 83.028,401.176 85.259,404.49 87.707,407.633 90.352,410.615 93.172,413.436 99.241,418.61 105.724,423.179 109.126,425.127 112.886,426.821 116.358,428.079 123.926,430.221 139.548,433.397 210.606,442.215 509.7,464.9 ",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2500,
    fillOpacity: 1,
    strokeOpacity: 1,
    className: "st0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFont1);
export default __webpack_public_path__ + "static/media/font1.e7b7f9244e08f750a7f5b340811b501a.svg";
export { ForwardRef as ReactComponent };